/** Font Awesome's own gallery of the free icons the issue icon field accepts. */
export const FONT_AWESOME_GALLERY = "https://fontawesome.com/v5/search?m=free";
